export default __webpack_public_path__ + "static/media/gasag.f62cc0cd.svg";